// extracted by mini-css-extract-plugin
module.exports = {"message-notifications":"styles_message-notifications__w8tK9"};